import { Duration } from 'moment';

import { Bank } from '@/api/dictionary';
import { SbpInvoiceAPIModel, SbpInvoiceAPIModelStatusEnum } from '@/generated/api/fps/core';
import { MoneyType, PhoneType } from '@/model/common';

export const NAMESPACE = 'INVOICE';

export enum InvoiceUIState {
  STATUS = 'status',
  DETAILS = 'details',
  BANKS = 'banks',
  BANK = 'bank',
}

export interface MonthlyLimitFromAPI {
  userId: string;
  amount: MoneyType;
  currentAmount: MoneyType;
  assetId: string;
  updatedAt: string;
}

export interface MonthlyLimit extends Omit<MonthlyLimitFromAPI, 'updatedAt'> {
  updatedAt: Date;
}

export interface OneTimeLimit {
  userId: string;
  amount: MoneyType;
  assetId: string;
}

export interface LimitsFromAPI {
  monthly?: MonthlyLimitFromAPI;
  oneTime?: OneTimeLimit;
}

export interface Limits extends Omit<LimitsFromAPI, 'monthly'> {
  monthly?: MonthlyLimit;
}

export enum InvoiceProcessingStatus {
  IN_PROGRESS = 'InProgress',
  SUCCEEDED = 'Succeeded',
  EXPIRED = 'Expired',
  FAILED = 'Failed',
}

export interface InvoiceDetails extends Omit<SbpInvoiceAPIModel, 'allocatedPhone'> {
  id: number;
  accountId: number;
  createdAt: Date;
  expiresAt: Date;
  allocatedPhone: PhoneType;
  status: SbpInvoiceAPIModelStatusEnum;
}

export enum InvoiceDetailsLoadError {
  NO_PHONE_IN_POOL = 'NO_PHONE_IN_POOL',
  COMMON = 'COMMON',
}

export interface State {
  initialized: boolean;
  banks: Bank[];
  limits?: Limits;
  details?: { value?: InvoiceDetails; error?: InvoiceDetailsLoadError };
  validPeriod?: Duration;
  processingStatus?: InvoiceProcessingStatus;
}

export const initialState: State = {
  initialized: false,
  banks: [],
};
